import {Component, Input, OnInit} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { OptionService } from "../option/option.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {EmbedService} from "../service/embed.service";

@Component({
    selector: 'thankyou-order-media',
    templateUrl: './thankyou-order.media.component.html',
    providers: [DecimalPipe]
})
export class ThankyouOrderMediaComponent implements OnInit {

    /**
     * the current step
     */
    @Input() step: string;

    /**
     * Embed URL if a video should be shown.
     */
    videoEmbedUrl: SafeResourceUrl;

    /**
     * url of an image instead the icon
     */
    thankyouImage: string;

    /**
     * Constructor
     * @param optionService
     * @param domSanitizer
     * @param embedService
     */
    constructor(private optionService: OptionService, private domSanitizer: DomSanitizer, private embedService: EmbedService) {}

    /**
     * called when initializing the component
     */
    ngOnInit() {
        // check if we want to show an thank you video
        if (this.optionService.getOption('video_url')) {
            this.videoEmbedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.getEmbedUrl(this.optionService.getOption('video_url')));
        }
        else if (this.optionService.getOption('thankyou_image')) {
            this.thankyouImage = this.optionService.getImageDirectory();
            this.thankyouImage += '/' + this.optionService.getOption('thankyou_image');
        }
    }

    /**
     * tries to extract the embed url for the iframe for youtube and vimeo
     * @param url
     */
    getEmbedUrl(url: string): string {
        const youtubeMatch = url.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/);
        if (youtubeMatch) {
            return 'https://www.youtube.com/embed/' + youtubeMatch[1];
        }
        const vimeoMatch = url.match(/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/);
        if (vimeoMatch) {
            return 'https://player.vimeo.com/video/' + vimeoMatch[4];
        }

        return '';
    }

    /**
     * Scroll to the top, if embeded
     */
    scrollUp(): void {
      this.embedService.scrollToTop(0);
    }
}
